const customSelectors = {
    itemArray: [],
};
var addons_total = 0, box_total = 0, subsc_price, selling_plan_id, membership_variant_id, membership_product_id, gender, shirt_size, style, glove_hand, glove_size, subsc_total, one_total;
let count = 0;

class subscriptionFlowJS {
    constructor() {
      // Preseleccionar género
        //   const defaultGender = document.querySelector('#gender-1'); 
        //   if (defaultGender) {
        //       defaultGender.click();
        //       document.querySelector('#sel_gender').innerHTML = defaultGender.dataset.genderName;
        //   }
          
        //   // Preseleccionar talla de camiseta (shirt size)
        //   const defaultShirtSize = document.querySelector('#size-5'); 
        //   if (defaultShirtSize) {
        //       defaultShirtSize.click();
        //       document.querySelector('#sel_shirt_size').innerHTML = defaultShirtSize.dataset.shirtSize;
        //   }
          
        //   // Preseleccionar estilo (style)
        //   const defaultStyle = document.querySelector('#style-11'); 
        //   if (defaultStyle) {
        //       defaultStyle.click();
        //       document.querySelector('#sel_style').innerHTML = defaultStyle.dataset.style;
        //   }
          
        //   // Preseleccionar mano (glove hand)
        //   const defaultGloveHand = document.querySelector('#hand-12');
        //   if (defaultGloveHand) {
        //       defaultGloveHand.click();
        //       document.querySelector('#sel_glove').innerHTML = defaultGloveHand.dataset.gloveHand;
        //   }
          
document.addEventListener('DOMContentLoaded', () => {
    const defaultMembership = document.querySelector('#membership-23');
    if (defaultMembership) {
        defaultMembership.checked = true;
        defaultMembership.dispatchEvent(new Event('change')); // Disparar el evento 'change'
    }
        // Preseleccionar género
          const defaultGender = document.querySelector('#gender-1'); 
          if (defaultGender) {
              defaultGender.click();
              document.querySelector('#sel_gender').innerHTML = defaultGender.dataset.genderName;
          }
          
          // Preseleccionar talla de camiseta (shirt size)
          const defaultShirtSize = document.querySelector('#size-5'); 
          if (defaultShirtSize) {
              defaultShirtSize.click();
              document.querySelector('#sel_shirt_size').innerHTML = defaultShirtSize.dataset.shirtSize;
          }
          
          // Preseleccionar estilo (style)
          const defaultStyle = document.querySelector('#style-11'); 
          if (defaultStyle) {
              defaultStyle.click();
              document.querySelector('#sel_style').innerHTML = defaultStyle.dataset.style;
          }
          
          // Preseleccionar mano (glove hand)
          const defaultGloveHand = document.querySelector('#hand-12');
          if (defaultGloveHand) {
              defaultGloveHand.click();
              document.querySelector('#sel_glove').innerHTML = defaultGloveHand.dataset.gloveHand;
          }
          const defaultGloveSize = document.querySelector('#glove-17');
            if(defaultGloveSize){
                defaultGloveSize.click();
                document.querySelector('#sel_glove_size').innerHTML = defaultGloveSize.dataset.gloveSize;
            
              
          }
          
          
});


          
        
        // From home page Subscription section select
        setTimeout(function(){
            document.querySelectorAll('.input-checkbox .gender').forEach((i, value) => {
            let gender = localStorage.getItem('genderVal');
            var radioVal = i.dataset.genderName;
            if (gender != null && gender != undefined && gender === radioVal) {
                i.click();
                localStorage.removeItem('genderVal');
            }
            })
        }, 1000);

        //sticky sidebar for mobile device
        this._stickySidebarMobile();

        // Select options from the subscription flow
        this._selectOptions();

        // Free item add
        this._getCartForFreeItem();
        document.querySelectorAll('[data-freeitem-add]').forEach(freeItemBtn => freeItemBtn.addEventListener('click', this._freeItemAddRemove.bind(this)));

        // Subscription page addon section item add
        document.querySelectorAll('[data-addonitem-add]').forEach(addonItemBtn => addonItemBtn.addEventListener('click', this._addonsItemAddRemove.bind(this)));

        // Subscribe button click
        document.querySelector('#subscribe_add').addEventListener('click', this._validateOnClick.bind(this));

    }
  


    _stickySidebarMobile(){
        let observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    document.querySelector('.slidebar-sticky').classList.remove('active');
                } else {
                    document.querySelector('.slidebar-sticky').classList.add('active');
                }
            })
        });
        let wrapper = document.querySelector('#slidebar');
        observer.observe(wrapper);

        document.querySelector('.slidebar-heading').addEventListener('click' , (event) => {
            event.preventDefault();
            let sidebarWrapper = document.querySelector('#slidebar .slidebar-sticky');
            let isOpen = sidebarWrapper.classList.contains('open');
            isOpen ? sidebarWrapper.classList.remove('open') : sidebarWrapper.classList.add('open');
        });
    }

    _selectOptions(){
        document.querySelectorAll('.gender').forEach((items) => {
            items.addEventListener('change', (event) => {
                var gender = event.target.dataset.genderName;
                document.querySelector('#sel_gender').innerHTML = gender;

                let downcase_gender = gender.toLowerCase();
                downcase_gender == 'female' ? document.querySelector('#choose_glove_size').classList.add(downcase_gender) : document.querySelector('#choose_glove_size').classList.remove('female');
                document.querySelectorAll('input[name="glove"]').forEach((j) => {
                    j.checked= false;
                });
                document.querySelector('#sel_glove_size').innerHTML = '-';
            });
        });
        document.querySelectorAll('.shirt_size').forEach((items) => {
            items.addEventListener('change', (event) => {
                var shirt_size = event.target.dataset.shirtSize;
                document.querySelector('#sel_shirt_size').innerHTML = shirt_size;
            });
        });
        document.querySelectorAll('.style').forEach((items) => {
            items.addEventListener('change', (event) => {
                var style = event.target.dataset.style;
                document.querySelector('#sel_style').innerHTML = style;
            });
        });
        document.querySelectorAll('.glove_hand').forEach((items) => {
            items.addEventListener('change', (event) => {
                var glove_hand = event.target.dataset.gloveHand;
                document.querySelector('#sel_glove').innerHTML = glove_hand;
            });
        });
        document.querySelectorAll('.glove_size').forEach((items) => {
            items.addEventListener('change', (event) => {
                var glove_size = event.target.dataset.gloveSize;
                document.querySelector('#sel_glove_size').innerHTML = glove_size;
                this._selectDefaultMembership();
              
            });
        });
        document.querySelectorAll('.membership').forEach((items) => {
            items.addEventListener('change', (e) => {
                var handle = e.target.dataset.product_handle;
                var membership_title = e.target.dataset.membership;
                var membership_total = e.target.dataset.membershipTotal;

                document.querySelector('#sel_membership').innerHTML = membership_title;
                document.querySelector('#sel_subsc_total').innerHTML = membership_total;

                fetch(`/products/${handle}.json`).then(response => {
                return response.json();
                }).then(response => {
                    const product = response.product;
                    subsc_price = product.variants[0].price;
                    if (document.querySelector('#addons_total_currency').getAttribute('data-addons-currency') != null) {
                      addons_total = document.querySelector('#addons_total_currency').getAttribute('data-addons-currency');
                    }
                    document.querySelector('#subsc_total_digit').setAttribute('data-membership-without-currency',subsc_price);
                    subsc_total = parseFloat(subsc_price).toFixed(2);
                    one_total = parseFloat(addons_total);
                    box_total = subsc_total + one_total;

                    if (!one_total == 0 && !box_total == '') {
                        document.querySelector('#sel_total').innerHTML = Shopify.formatMoney(box_total.toString(), window.globalVariables.money_format);
                    } else {
                      document.querySelector('#sel_total').innerHTML = Shopify.formatMoney(subsc_total.toString(), window.globalVariables.money_format);
                    }
                });
                selling_plan_id = e.target.dataset.sellingId;
                membership_variant_id = e.target.dataset.membershipVariantId;
            })
        })
    }
  // _selectDefaultMembership() {
  //         // Establece la membresía predeterminada como seleccionada automáticamente.
  //         const defaultMembership = document.querySelector('#membership-23');
  //         if (defaultMembership) {
  //             // Simula el clic en la membresía predeterminada.
  //             defaultMembership.click();
  //         }
  //     }

    _checkButtonStatus(event){
        if (event.currentTarget.classList.contains('active')) {
            event.currentTarget.querySelector('.add-txt').classList.add('d-none');
            event.currentTarget.querySelector('.added-txt').classList.remove('d-none');
            event.currentTarget.querySelector('.added-txt').classList.add('d-flex');
        }else{
            event.currentTarget.querySelector('.add-txt').classList.remove('d-none');
            event.currentTarget.querySelector('.added-txt').classList.add('d-none');
            event.currentTarget.querySelector('.added-txt').classList.remove('d-flex');
        }
    }

    _getCartForFreeItem(){
        fetch(`${routes.cart_fetch_url}.json`).then(response => {
          return response.json();
        }).then(response => {
            response.items.forEach((i) => {
              if (i.properties.bogo_free == "true" && i.item_count >= 1) {
                const config = {
                    "id": i.variant_id,
                    "quantity": 0
                };
                fetch(`${routes.cart_change_url}.js`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(config)
                })
                .then(() => {
                    count = 0;
                    document.querySelector('.sub-addon .error_msg').classList.add('d-none');
                })
                .catch((e) => {
                    console.error(e);
                })
              }
            })
        });
    }

    _freeItemAddRemove(event){
        var currentTarget = event.currentTarget;
        currentTarget.classList.toggle('active');
        this._checkButtonStatus(event);
        var data = {};

        fetch(`${routes.cart_fetch_url}.json`).then(response => {
          return response.json();
        }).then(response => {
            response.items.forEach((i) => {
              if (i.properties.bogo_free == "true") {
                count = 1;
              }
            })
        });

        var allowedItemsCount = document.querySelector('[data-freeitemcontainer]').getAttribute('data-totalallowed');
        if (count == allowedItemsCount) {
            if (currentTarget.classList.contains('active')) {
                document.querySelector('.sub-addon .error_msg').classList.remove('d-none');
                currentTarget.classList.remove('active');
                currentTarget.querySelector('.add-txt').classList.remove('d-none');
                currentTarget.querySelector('.added-txt').classList.add('d-none');
            } else {
                const id = currentTarget.dataset.variant_id;
                customSelectors.itemArray = customSelectors.itemArray.filter((ele) => {
                    return ele.id != id;
                });
                count = 0;
                document.querySelector('.sub-addon .error_msg').classList.add('d-none');
            }
        } else {
            if (currentTarget.classList.contains('active')) {
                document.querySelector('.sub-addon .error_msg').classList.add('d-none');
                count++;
                if (count === 1) {
                    data = {
                        "id": parseInt(currentTarget.dataset.variant_id),
                        "quantity": 1,
                        "properties": {
                            "one_time": true,
                            "bogo_free": true
                        }
                    };
                    customSelectors.itemArray.push(data);
                    count = 1;
                }
            } else{
                const id = currentTarget.dataset.variant_id;
                customSelectors.itemArray = customSelectors.itemArray.filter((ele) => {
                    return ele.id != id;
                });
                count = 0;
                document.querySelector('.sub-addon .error_msg').classList.add('d-none');
            }
        }


    }

    _addonsItemAddRemove(event){
        var currentTarget = event.currentTarget;
        currentTarget.classList.toggle('active');
        this._checkButtonStatus(event);
        var data = {};
        var addons_handle = currentTarget.dataset.addons_handle;

        if (currentTarget.classList.contains('active')) {
            const data = {
                "id": parseInt(currentTarget.dataset.variant_id),
                "quantity": 1,
                "properties": {
                    "one_time": true
                }
            }
            customSelectors.itemArray.push(data);
            fetch(`/products/${addons_handle}.json`).then(response => {
                return response.json();
                }).then(response => {
                const product = response.product;
                addons_total +=  parseFloat(product.variants[0].price);

                console.log('addons price addd');
                document.querySelector('#sel_one_total').innerHTML = Shopify.formatMoney(addons_total.toFixed(2).toString(), window.globalVariables.money_format);
                subsc_total = document.querySelector('#subsc_total_digit').getAttribute('data-membership-without-currency');
                one_total = parseFloat(addons_total);
                box_total = (parseFloat(subsc_total) + parseFloat(one_total));

                document.querySelector('#addons_total_currency').setAttribute('data-addons-currency', addons_total);
                    document.querySelector('#sel_total').innerHTML = Shopify.formatMoney(box_total.toFixed(2).toString(), window.globalVariables.money_format);
                    // box_total = parseFloat(box_total);
            });
        } else{
            const id = currentTarget.dataset.variant_id;
            customSelectors.itemArray = customSelectors.itemArray.filter((ele) => {
                return ele.id != id;
            });
            fetch(`/products/${addons_handle}.json`).then(response => {
                return response.json();
                }).then(response => {
                const product = response.product;
                addons_total -=  parseFloat(product.variants[0].price);

                console.log('addons price remove');
                document.querySelector('#sel_one_total').innerHTML = Shopify.formatMoney(addons_total.toFixed(2).toString(), window.globalVariables.money_format);
                subsc_total = document.querySelector('#subsc_total_digit').getAttribute('data-membership-without-currency');
                one_total = parseFloat(addons_total);
                box_total = parseFloat(subsc_total) + parseFloat(one_total);
                document.querySelector('#addons_total_currency').setAttribute('data-addons-currency', addons_total);
                document.querySelector('#sel_total').innerHTML = Shopify.formatMoney(box_total.toString(), window.globalVariables.money_format);
                //  document.querySelector('#sel_total').innerHTML = Shopify.formatMoney(box_total.toFixed(2).toString(), window.globalVariables.money_format);
                // box_total = parseFloat(box_total);
            });
        }
    }

    _validateOnClick(event){
        gender = document.querySelector('#sel_gender').innerHTML;
        shirt_size = document.querySelector('#sel_shirt_size').innerHTML;
        style = document.querySelector('#sel_style').innerHTML;
        glove_hand = document.querySelector('#sel_glove').innerHTML;
        glove_size = document.querySelector('#sel_glove_size').innerHTML;
        var membership_txt = document.querySelector('#sel_membership').innerHTML;

        document.querySelector('#gender_txt').classList.remove('text-danger');
        document.querySelector('#shirt_size_txt').classList.remove('text-danger');
        document.querySelector('#style_txt').classList.remove('text-danger');
        document.querySelector('#glove_hand_txt').classList.remove('text-danger');
        document.querySelector('#glove_size_txt').classList.remove('text-danger');
        // document.querySelector('#membership_txt').classList.remove('text-danger');

        var scrollDiv = null;
        if (gender == '-' || gender == null) {
        document.querySelector('#gender_txt').classList.add('text-danger');
        if(scrollDiv == null) scrollDiv = document.querySelector("#gender_txt").offsetTop - 100;
        }
        if (shirt_size == '-' || shirt_size == null) {
        document.querySelector('#shirt_size_txt').classList.add('text-danger');
        if(scrollDiv == null) scrollDiv = document.querySelector("#shirt_size_txt").offsetTop - 100;
        }
        if (style == '-' || style == null) {
        document.querySelector('#style_txt').classList.add('text-danger');
        if(scrollDiv == null) scrollDiv = document.querySelector("#style_txt").offsetTop - 100;
        }
        if (glove_hand == '-' || glove_hand == null) {
        document.querySelector('#glove_hand_txt').classList.add('text-danger');
        if(scrollDiv == null) scrollDiv = document.querySelector("#glove_hand_txt").offsetTop - 100;
        }
        if (glove_size == '-' || glove_size == null) {
        document.querySelector('#glove_size_txt').classList.add('text-danger');
        if(scrollDiv == null) scrollDiv = document.querySelector("#glove_size_txt").offsetTop - 100;
        }
        if (membership_txt == '-' || membership_txt == null) {
        document.querySelector('#membership_txt').classList.add('text-danger');
        if(scrollDiv == null) scrollDiv = document.querySelector("#membership_txt").offsetTop - 100;
        }
        if(scrollDiv != null){
        window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
        } else {
            if (membership_variant_id != undefined && selling_plan_id != undefined && gender != undefined && gender != shirt_size && gender != style && gender != glove_hand && gender != glove_size ) {
                const data = {
                    "id": parseInt(membership_variant_id),
                    "quantity": 1,
                    "selling_plan": parseInt(selling_plan_id),
                    "properties": {
                    "Gender": gender,
                    "Shirt Size": shirt_size,
                    "Style":  style,
                    "Glove Hand": glove_hand,
                    "Glove Size": glove_size
                    }
                }
                customSelectors.itemArray.push(data);
            }
            this._submitHandler(event);
        }
    }

    async _displayCartItemPopup(type){
        var upsellLength = document.querySelectorAll('[data-upsell-item]').length;
        var count = 0;
        if(type != 'modal addon') {
            document.querySelectorAll('[data-upsell-item]').forEach((y)=>{
                y.classList.remove('hide');
            });
        }

       await fetch(`${routes.cart_fetch_url}.json`).then(response => {
          return response.json();
        }).then(response => {
            let innerHTML = '';
            if (response.item_count > 0){
                response.items.forEach((item, i) => {

                    if(document.querySelector(`[data-upsell-item][data-id="${item.product_id}"]`) != null){
                        document.querySelectorAll(`[data-upsell-item][data-id="${item.product_id}"]`).forEach((upsell_item)=>{
                            upsell_item.classList.add('hide');
                        });
                    }
                    document.querySelectorAll('[data-upsell-item]').forEach((y)=>{
                        if(y.getAttribute('data-id') == item.product_id){
                        count++;
                        }
                    });

                    var prop = '';
                    var timespan = '';
                    if(item.properties){
                        for(var p in item.properties){
                        if(p == '__timespan') timespan = item.properties[p];
                        if(p.charAt(0) != '_'){
                            prop += `<li><span class="product-details__item-label fw-semibold">${p}: </span><span>${item.properties[p]}</span></li>`;
                        }
                        }
                    }
                    innerHTML += `
                        <div class="upsell-cart-item d-flex py-3 border-bottom">
                            <div class="cart-item-img me-3">
                                <img src="${ item.image != null ? item.image : 'https://cdn.shopify.com/s/files/1/0561/0530/4256/files/mully-placeholder.png?v=1676033540'}" alt="${item.title}" class="w-100">
                            </div>
                            <div class="cart-item-txt w-100">
                                <div class="item-title-remove d-flex justify-content-between align-items-center mb-1">
                                    <h6 class="font-size-base mb-0 text-capitalize"><a href="${item.url}">${item.title}</a></h6>
                                    <a href="javascript:void(0);" class="remove-cart" data-item-remove key="${item.key}" data-line="${i + 1}" data-id="${item.id}" timespan="${timespan}"><span class="icon-close"></span>
                                    </a>
                                </div>
                                <div class="item-price-details d-flex justify-content-between align-items-end">
                                    <ul class="product-details list-unstyled mb-0">
                                        ${ item.selling_plan_allocation != null ? `<li>${item.selling_plan_allocation.selling_plan.name}</li>` : '' } ${ prop }
                                    </ul>
                                    <span class="item-total">${Shopify.formatMoney(item.line_price, window.globalVariables.money_format)}</span>
                                </div>
                            </div>
                        </div>`;
                });
                document.querySelector('[data-subtotal]').textContent = Shopify.formatMoney(response.total_price, window.globalVariables.money_format);
                if(upsellLength == count) {
                    document.querySelector('#cartpopup-modal .upsell-box').classList.add('hide-upsell');
                } else{
                    document.querySelector('#cartpopup-modal .upsell-box').classList.remove('hide-upsell');
                }
            } else {
                innerHTML += `<div class="not-product-cart text-center">
                    <p class="cart__empty-text font-size-lg mt-5">Your cart is currently empty.</p>
                    <a href="{{ routes.all_products_collection_url }}" class="link text-primary">Continue shopping</a>
                    </div>`;
                document.querySelector('[data-cart-footer]').classList.add('hide');
                document.querySelector('#cartpopup-modal .upsell-box').classList.add('hide-upsell');
            }
            document.querySelector('[data-upsell-body]').innerHTML = innerHTML;


            //Remove item form the popup
            document.querySelectorAll('[data-item-remove]').forEach(removeItem => removeItem.addEventListener('click', this._removeItem.bind(this)));

        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            // Cart HTML fetch done
        });
    }

    async _submitHandler(event) {
    event.preventDefault();
    const submitButton = document.querySelector('[data-add-to-cart] #subscribe_add');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
        items: customSelectors.itemArray
    });

    fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: body
    })
    .then((response) => response.json())
    .then(() => {
        // Redirige al usuario al carrito de compras de Shopify
        window.location.href = '/checkout';

        // Opcionalmente, podrías abrir el carrito en una nueva pestaña
        // window.open('/cart', '_blank');

        // También puedes mantener el comportamiento original de mostrar un popup y un overlay
        // document.querySelector('#cartpopup-modal .modal').classList.add('open');
        // siteOverlay.prototype.showOverlay();
        // this._displayCartItemPopup('flow page');

        // Desmarca varios elementos de entrada del formulario
        document.querySelector('input[name="gender"]:checked').checked = false;
        document.querySelector('input[name="size"]:checked').checked = false;
        document.querySelector('input[name="style"]:checked').checked = false;
        document.querySelector('input[name="hand"]:checked').checked = false;
        document.querySelectorAll('input[name="glove"]').forEach((j) => {
            j.checked= false;
        });
        document.querySelector('input[name="membership"]:checked').checked = false;
    })
    .catch((e) => {
        console.error(e);
    })
    .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
    });
}


    _addAddonsFromPopup(event){
        var currentTarget = event.currentTarget;
        currentTarget.setAttribute('disabled', true);
        currentTarget.classList.add('loading');
        var currentForm = currentTarget.closest('[data-upsell-item]').querySelector('form');

        var data = {};
        currentForm.querySelectorAll('input').forEach((option) => {
          let name = option.getAttribute('name');
          data[name] = option.value;
        });
        var addonArray = [];
        addonArray.push(data);
        const body = JSON.stringify({
            items: addonArray
        });
        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
        .then((response) => response.json())
        .then(() => {
            this._displayCartItemPopup('modal addon');
        })
        .catch((e) => {
            console.error(e);
        })
        .finally(() => {
            currentTarget.classList.remove('loading');
            currentTarget.removeAttribute('disabled');
            currentTarget.querySelector('[data-upsell-item]').classList.add('hide');
        });
    }

    _removeItem(event){
        event.preventDefault();
        var currentTarget = event.currentTarget;
        let line = currentTarget.dataset.line || null;
        if(line != null) {
            let lineItem = document.querySelectorAll('.upsell-cart-item')[line-1];

            if(lineItem){ lineItem.classList.add('updating'); }

            let quantity = 0;
            const body = JSON.stringify({
                line,
                quantity
            });
            fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
            .then((response) => {
                return response.text();
            })
            .then((_state) => {
            this._displayCartItemPopup('remove');
            setTimeout(() => {
                if(lineItem){ lineItem.classList.remove('updating'); }
            }, 1000);
            }).catch((error) => {
            console.log(error);
            });
        }


    }

    _proccedToCheckout(event){
        event.currentTarget.setAttribute('disabled', true);
        event.currentTarget.classList.add('loading');
        window.location.href = "/checkout";
    }

}

typeof subscriptionFlowJS !== 'undefined' && new subscriptionFlowJS();